<template>
  <v-container class="pa-0">
    <v-toolbar dense flat color="transparent" class="mt-3">
      <v-row no-gutters>
        <v-col cols="4">
          <NoteNavigationLeft
            @onHome="onHome"
            @onBack="onBack"
            @onClose="onClose"
            @onNoteSetting="onNoteSetting"
            :canHome="canHome"
            :canClose="canClose"
          />
        </v-col>
        <v-col cols="4" align="center">
          <!-- space -->
        </v-col>
        <v-col cols="4" align="right">
          <NoteNavigationRight
            @onPrev="onPrev"
            @onNext="onNext"
            @onClose="onClose"
            :canHome="canHome"
            :isPrev="isPrev"
            :isNext="isNext"
            :single="single"
          />
        </v-col> </v-row
    ></v-toolbar>
    <!-- <v-divider />
    <RelatedNoteHistory :guid="note.guid" />-->
    <v-card class="mx-2" :loading="loading">
      <v-card-title class="px-2">
        <v-container class="pa-0">
          <v-row v-if="loading" class="mt-n3">
            <v-col align="center">
              <v-icon color="grey darken-3">mdi-progress-download</v-icon>
              <span class="ml-2 body-2">読み込み中...</span>
              <div></div>
              <v-divider class="my-3" />
            </v-col>
          </v-row>
          <v-row no-gutters v-if="note.isAd">
            <v-col class="font-weight-bold">
              {{ adData.title }}
            </v-col>
          </v-row>
          <v-row no-gutters v-else>
            <v-col>
              <table width="100%">
                <tr>
                  <td style="vertical-align: top">
                    <div @click="onTitle" class="primary--text">
                      <img
                        class="coverimage_1 mb-1"
                        :src="coverImageSrc"
                        v-if="coverImageSrc"
                      />
                      <h1>
                        {{ note.title }}
                        <NoteViewsChip
                          :count="noteViews"
                          v-if="!loading && note.guid"
                        />
                      </h1>

                      <!-- <v-btn icon @click="onTitle" v-if="note.title" class="mt-n1">
                        <v-icon
                          small
                          :color="
                            $vuetify.theme.dark
                              ? 'grey lighten-2'
                              : 'grey darken-1'
                          "
                        >mdi-circle-edit-outline</v-icon>
                      </v-btn>-->
                    </div>
                    <!-- </td>
                    <td style="vertical-align: top" align="right">-->
                    <!-- <img class="coverimage_1 mb-1" :src="coverImageSrc" v-if="coverImageSrc" /> -->
                  </td>
                </tr>
              </table>
            </v-col>
          </v-row>
          <template v-if="!note.isAd">
            <v-row>
              <v-col class="px-0 py-1" align="right">
                <v-chip
                  @click="onNotebook"
                  color="transparent"
                  text-color="indigo lighten-1"
                  outlined
                  v-if="note.notebookGuid"
                  style="font-size: 12pt"
                >
                  {{ evernote.getNotebookName(note.notebookGuid) }}
                  <!-- <v-icon small class="ml-2">mdi-circle-edit-outline</v-icon> -->
                </v-chip>
                <v-chip
                  @click="onTag"
                  v-for="tag in evernote.getTagNames(note.tagGuids)"
                  :key="tag.guid"
                  color="transparent"
                  text-color="amber"
                  outlined
                  style="font-size: 12pt"
                >
                  {{ tag.name }}
                  <!-- <v-icon small class="ml-2">mdi-circle-edit-outline</v-icon> -->
                </v-chip>
                <v-chip
                  @click="onTag"
                  text-color="amber"
                  color="transparent"
                  outlined
                  v-if="note.guid && (!note.tagGuids || !note.tagGuids.length)"
                >
                  <v-icon small class="mr-1">mdi-tag-plus</v-icon>タグ
                </v-chip>
              </v-col>
            </v-row>
            <v-row no-gutters align="end">
              <v-col cols="6">
                <!-- largestResourceMimeは一覧で毎回取得しているnotemetaのみに含まれる為、ここでは使えない 2020-10-02 -->
                <!-- <span class="mr-1">
                <v-icon
                  small
                  class="mt-n1"
                  color="red lighten-1"
                  v-if="
                    note.largestResourceMime &&
                      note.largestResourceMime.match(/pdf$/)
                  "
                >mdi-file-pdf-box</v-icon>
                <v-icon
                  small
                  class="mt-n1"
                  color="green lighten-1"
                  v-else-if="
                    note.largestResourceMime &&
                      note.largestResourceMime.match(/^image\//)
                  "
                >mdi-image</v-icon>
              </span>-->
                <v-chip
                  label
                  class="px-1 body-2 grey--text"
                  color="transparent"
                >
                  {{ dateService.getFormattedShort(note.created) }}
                </v-chip>

                <template
                  v-if="note.attributes && note.attributes.reminderOrder"
                >
                  <v-chip
                    class="ml-n3"
                    small
                    outlined
                    @click="onReminder"
                    color="transparent"
                    :text-color="evernote.getReminderColorWithNote(note)"
                  >
                    <v-icon class="mr-1" small>
                      {{
                        note.attributes.reminderDoneTime
                          ? 'mdi-clock-check-outline'
                          : 'mdi-alarm'
                      }}
                    </v-icon>
                    <span class="body-2">
                      {{
                        evernote.getAltReminderTime(note)
                          ? dateService.getFormatted(
                              evernote.getAltReminderTime(note)
                            )
                          : 'リマインダあり'
                      }}
                    </span>
                    <!-- <v-icon small class="ml-2">mdi-circle-edit-outline</v-icon> -->
                  </v-chip>
                </template>
                <template
                  v-if="
                    note.attributes &&
                      note.attributes.reminderOrder == undefined
                  "
                >
                  <v-btn
                    @click.stop="onReminder(note)"
                    small
                    color="transparent"
                    fab
                    elevation="0"
                  >
                    <v-icon
                      :color="$vuetify.theme.dark ? 'grey lighten-2' : 'grey'"
                      >mdi-alarm-plus</v-icon
                    >
                  </v-btn>
                </template>
                <!-- <v-chip x-small>{{ note.updateSequenceNum }}</v-chip> -->
              </v-col>

              <v-col align="right">
                <NoteToolbar
                  :note="note"
                  @onChange="onChange"
                  @onDelete="onDelete"
                  @onFavorite="onFavorite"
                  @onNoteNewTab="onNoteNewTab"
                  :large="false"
                  v-if="!loading"
                />
              </v-col>
            </v-row>
          </template>
        </v-container>
      </v-card-title>
      <RelatedNoteList
        :guid="note.guid"
        @click="onNote($event)"
        @clickInNew="onNoteNewTab($event)"
        v-if="!loading && !note.isAd"
        class="mb-3"
      />
      <!-- <v-divider class="mx-2" v-if="note.guid" /> -->
      <v-card-text v-if="note.isAd">
        <AdCard :adData="adData" />
      </v-card-text>
      <v-card-text v-else class="scroll my-0 py-0">
        <v-row no-gutters class="ml-n2" v-if="!loading && note.guid">
          <v-col>
            <div v-if="imageLoading && numberOfImages > 3" class="mt-0 mb-2">
              <v-icon small class="ml-1">mdi-image</v-icon>
              {{ numberOfDisplayedImage }} /
              {{ numberOfImages }}
              <v-progress-linear
                :value="rateOfDownloadingImages"
                :buffer-value="100"
                stream
                class="ml-1"
              ></v-progress-linear>
            </div>
            <!-- <v-btn icon @click="deleteDialog = true">
              <v-icon>mdi-trash-can</v-icon>
            </v-btn>
            <v-btn icon @click="onReload">
              <v-icon>mdi-reload</v-icon>
            </v-btn> -->

            <!-- <v-chip
              small
              class="mr-2 py-3 px-2"
              label
              :outlined="!relatedNoteExpanded"
              @click="onRelatedNote"
              >関連ノート</v-chip
            > -->
            <!-- <template v-if="settings.isImageDownloadManual">
              <v-chip
                small
                label
                class="py-3 px-2 mr-1"
                outlined
                @click="onNoteSetting"
              >
                <v-progress-circular
                  size="12"
                  width="1"
                  indeterminate
                  class="mr-1"
                  v-if="imageLoading"
                ></v-progress-circular>
                {{ settings.imageDownloadModeList[1].label }}
                <span v-if="imageLoading" class="ml-1">
                  {{ numberOfDisplayedImage }} / {{ numberOfImages }}</span
                >
              </v-chip>
              <v-btn
                icon
                small
                @click="onDownloadImages"
                v-if="hasImages"
                :disabled="imageLoading || allImagesDisplayed"
                class="mr-n1"
              >
                <v-icon>
                  {{
                    allImagesDisplayed
                      ? 'mdi-download-off'
                      : 'mdi-download-circle'
                  }}
                </v-icon>
              </v-btn>
            </template> -->
            <!-- <template v-else>
              <v-chip
                small
                class="py-3 px-2"
                label
                outlined
                @click="onNoteSetting"
              >
                <v-progress-circular
                  size="12"
                  width="1"
                  indeterminate
                  class="mr-1"
                  v-if="imageLoading"
                ></v-progress-circular>
                {{ settings.imageDownloadModeList[0].label }}
                <span v-if="imageLoading" class="ml-1">
                  {{ numberOfDisplayedImage }} / {{ numberOfImages }}</span
                >
              </v-chip>
            </template> -->
          </v-col>
        </v-row>
        <v-row no-gutters class="mb-3" v-if="!loading && firstPart">
          <v-col cols="4">
            <v-btn x-small icon @click="onFirstPart" outlined>
              <v-icon>
                {{ firstPartShow ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-expand-transition>
          <div
            class="content mt-2 first_part"
            v-html="firstPart"
            v-show="firstPartShow"
            @click.stop="onFirstPart"
            ref="firstPart"
          ></div>
        </v-expand-transition>
        <div
          class="noteBody"
          :style="contentStyle"
          v-html="contentPart"
          ref="contentDiv"
        ></div>
        <AdCard :adData="adData" place="Detail" v-if="!hideAd" />
      </v-card-text>
    </v-card>
    <v-toolbar dense flat color="transparent" v-if="!loading">
      <v-row no-gutters>
        <v-col cols="4">
          <NoteNavigationLeft
            @onHome="onHome"
            @onBack="onBack"
            @onClose="onClose"
            @onNoteSetting="onNoteSetting"
            :canHome="canHome"
            :canClose="canClose"
          />
        </v-col>
        <v-col cols="4" align="center">
          <template v-if="!note.isAd">
            <v-chip
              v-if="!loading && !note.isAd"
              @click="onCacheInfo"
              small
              class="py-3 px-2 mt-3 primary--text"
              outlined
              color="transparent"
              label
            >
              <span v-if="isCache">
                <v-icon small class="mr-1">mdi-database-clock </v-icon
                >キャッシュ利用 </span
              ><span v-else>最新</span>
            </v-chip>
          </template>
        </v-col>
        <v-col cols="4" align="right">
          <NoteNavigationRight
            @onPrev="onPrev"
            @onNext="onNext"
            :canHome="canHome"
            :isPrev="isPrev"
            :isNext="isNext"
            :single="single"
          />
        </v-col>
      </v-row>

      <!-- <v-chip icon @click="onCacheInfo" color="transparent" dense>
        <v-icon small class="mr-2">mdi-database-check</v-icon>
        <span class="overline">
          {{ dateService.getFormatted(note.updated) }}
        </span>
      </v-chip> -->
    </v-toolbar>
    <ChangeDialog ref="changeDialog" />
    <DeleteDialog ref="deleteDialog" />
    <!-- <NetworkProcessDialog ref="moveToTrashDialog" @processed="onDeleted" /> -->
    <NetworkProcessDialog ref="loadResourceDialog" />
    <!-- <v-dialog v-model="deleteDialog" width="320">
      <v-card>
        <v-card-title>
          <v-icon class="mr-2">mdi-trash-can</v-icon>
          {{ note.title }}
        </v-card-title>
        <v-card-text>
          このノートをゴミ箱へ移動します。
          <br />元に戻す場合は Evernoteでゴミ箱から復元してください。
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="deleteDialog = false">キャンセル</v-btn>
          <v-btn text @click="onDelete">実行</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <!-- <v-dialog v-model="reloadTestDialog" width="450px" persistent>
      <v-card>
        <v-card-title>API呼び出し回数制限超えテスト</v-card-title>
        <v-card-text>
          <div class="py-2">
            呼び出し回数：{{ reloadTestCounter }}
            <v-progress-linear
              class="my-2"
              :indeterminate="reloadTestState == 1"
              striped
            ></v-progress-linear>
          </div>
          <div class="py-2">{{ reloadTestMessage }}</div>
          <div>{{ reloadTestResult }}</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <template v-if="reloadTestState == 0">
            <v-btn text @click="reloadTestDialog = false">キャンセル</v-btn>
            <v-btn text @click="onReloadTestChange(1)">開始</v-btn>
          </template>
          <template v-if="reloadTestState == 1">
            <v-btn text @click="onReloadTestChange(2)">キャンセル</v-btn>
          </template>
          <template v-if="reloadTestState >= 2">
            <v-btn text @click="reloadTestDialog = false">閉じる</v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog> -->

    <v-dialog v-model="errorDialog" width="450px" persistent>
      <v-card>
        <v-card-title>
          <v-icon class="mr-2">mdi-alert-circle</v-icon>エラー
        </v-card-title>
        <v-card-text>
          <div>{{ context.state.message }}</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="errorDialog = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DownloadImagesDialog ref="downloadImagesDialog" />
    <CacheInfoDialog ref="cacheInfoDialog" />
    <PreviewDialog ref="previewDialog" />
    <FavoriteUpdater ref="favoriteUpdater" />
    <HelpDialog ref="helpDialog" />
    <NoteSettingDialog ref="noteSettingDialog" />
  </v-container>
</template>

<script>
import evernote from '@/services/EvernoteService'
import textService from '@/services/TextService'
import dateService from '@/services/DateService'
import indexedDB from '@/services/IndexedDBService'
import stateService from '@/services/StateService'
import nhService from '@/services/NoteHistoryService'
import rdsService from '@/services/ResourceDisplayService'
import noteViewsService from '@/services/NoteViewsService'
import favoriteService from '@/services/FavoriteService'
import settings from '@/services/SettingsService'
import adService from '@/services/AdService'
import noteMeta from '@/services/NoteMeta'
import notesCache from '@/services/NotesCacheService'

import ChangeDialog from '@/components/dialogs/ChangeDialog'
import NetworkProcessDialog from '@/components/dialogs/NetworkProcessDialog'
import DownloadImagesDialog from '@/components/dialogs/DownloadImagesDialog'
import CacheInfoDialog from '@/components/dialogs/CacheInfoDialog'
import PreviewDialog from '@/components/dialogs/PreviewDialog'
import HelpDialog from '@/components/dialogs/HelpDialog'
import NoteSettingDialog from '@/components/dialogs/NoteSettingDialog'
import DeleteDialog from '@/components/dialogs/DeleteDialog'

import NoteToolbar from '@/components/parts/NoteToolbar'
import RelatedNoteList from '@/components/parts/RelatedNoteList'
import NoteNavigationLeft from '@/components/parts/NoteNavigationLeft'
import NoteNavigationRight from '@/components/parts/NoteNavigationRight'
import FavoriteUpdater from '@/components/parts/FavoriteUpdater'
import AdCard from '@/components/parts/AdCard'
import NoteViewsChip from '@/components/parts/NoteViewsChip'

export default {
  components: {
    ChangeDialog,
    NetworkProcessDialog,
    DownloadImagesDialog,
    NoteToolbar,
    CacheInfoDialog,
    PreviewDialog,
    RelatedNoteList,
    NoteNavigationLeft,
    FavoriteUpdater,
    HelpDialog,
    AdCard,
    NoteSettingDialog,
    NoteViewsChip,
    NoteNavigationRight,
    DeleteDialog
  },
  data() {
    return {
      note: {},
      firstPart: '',
      contentPart: '',
      firstPartShow: false,
      reloadTestDialog: false,
      reloadTestCounter: 0,
      reloadTestMessage: '',
      reloadTestResult: '',
      reloadTestState: 0,
      context: undefined,
      errorDialog: false,
      // deleteDialog: false,
      contentStyle: {
        lineHeight: '1.8em',
        fontSize: '14pt'
      },
      hasImages: false,
      allImagesDisplayed: false,
      noteViews: undefined,
      coverImageSrc: undefined,
      isCache: false,
      adData: {},
      hideAd: false,
      imageLoading: false,
      numberOfDisplayedImage: 0,
      numberOfImages: 0
    }
  },
  props: {
    guid: {
      type: String
    },
    usn: {
      // usn=Update Sequence Number
      type: Number
    },
    single: {
      type: Boolean
    }
  },
  watch: {
    guid: function(value) {
      // 決して消してはいけない !!
      if (value) {
        this.note = evernote.emptyNote
        this.load()
      }
    },
    note: function(value) {
      if (value && value.content) {
        const content = textService.sanitaize(value.content)
        // console.log(content)
        const index = textService.indexOfFirstHeaderTag(content)
        // console.log(index)
        // if (index > 120) {
        if (index > 60) {
          // 一定以上の長さで発動
          this.firstPart = content.substring(0, index)
          this.contentPart = content.substring(index)
        } else {
          this.firstPart = ''
          this.contentPart = content
        }
      } else {
        this.firstPart = ''
        this.contentPart = ''
      }
      // TODO
      this.$store.commit('setResources', this.evernote.getResources(value))
      // TODO
      this.$store.commit(
        'setResourceHashes',
        this.evernote.getResourceHashes(value)
      )
      //-->
      this.$nextTick(() => {
        if (!this.note.isAd) {
          this.$refs['contentDiv'].addEventListener(
            'click',
            this.onContentObject,
            true
          )
          this.loadInitialReources()
        }
      })
      // ↑第３引数=true が無いと Safariではイベントがハンドルできない
      // イベントがハンドルできない場合は evernote.getResourceHashes の正規表現を見直す
      // mountedから移動

      nhService.put(value.guid)
    }
  },
  computed: {
    evernote: () => evernote,
    dateService: () => dateService,
    noteGuids: () => notesCache.noteGuids,
    indexOfNotes: vm => vm.noteGuids.indexOf(vm.guid),
    isPrev: vm => vm.indexOfNotes > 0,
    isNext: vm =>
      vm.noteGuids.length ? vm.indexOfNotes < vm.noteGuids.length - 1 : false,
    canHome: vm => {
      return vm.noteGuids && vm.noteGuids.length > 0
    },
    canClose: () => window.opener != undefined,
    loading: vm => vm.context.state === vm.context.Processing,
    favoriteService: () => favoriteService,
    settings: () => settings,
    rateOfDownloadingImages: vm =>
      vm.numberOfImages
        ? ((vm.numberOfDisplayedImage + 1) / vm.numberOfImages) * 100
        : 0
  },
  mounted() {
    this.hideAd = true
    this.setupFontSize()
    if (indexedDB.initialized) {
      this.load()
    } else {
      indexedDB.callback = this.load
    }
  },
  created() {
    this.context = stateService.createContext({
      Exception: {
        message:
          'ネットワークエラーが発生しました。インターネットに接続しているか確認してみてください。'
      }
    })
  },
  methods: {
    doPostProcessing() {
      this.hideThubnail()
      this.noteViews = 0
      this.hideAd = true
      rdsService.revokeObjectURLs()
    },
    addNoteViews(guid) {
      this.noteViews = undefined
      noteViewsService.add(guid).then(() => {
        noteViewsService.count(guid).then(count => {
          this.noteViews = count
        })
      })
    },
    reload() {
      this.isCache = false
      noteMeta.setupRepresentedResource()
      this.context.changeStateTo(this.context.Processing)
      evernote
        .note(this.guid)
        .then(results => {
          if (!results.failed) {
            indexedDB.notes.put(results.note).then(() => {
              this.note = results.note
              this.addNoteViews(this.note.guid)
              // this.loadThumbnail()
              this.hideAd = false
              this.context.changeStateTo(this.context.Succeeded)
            })
          } else {
            this.context.changeStateTo(
              this.context.Failed,
              results.errorMessage
            )
            this.errorDialog = true
          }
        })
        .catch(error => {
          this.context.changeStateTo(this.context.Exception, error.toString())
        })
    },
    loadAd() {
      adService
        .loadAdData()
        .then(adData => {
          this.adData = adData
        })
        .catch(error => {
          console.log(error)
        })
    },
    load() {
      this.loadAd()
      noteMeta.setupRepresentedResource()
      if (this.guid == adService.guid) {
        this.note = adService.adNotePlaceholder
      } else if (this.guid) {
        indexedDB.notes.get(this.guid).then(note => {
          if (note) {
            this.note = note
            // console.log(
            //   `updateSequenceNum: usn=${this.usn}, cache=${this.note.updateSequenceNum}`
            // )
            if (!this.usn || this.usn == this.note.updateSequenceNum) {
              // usnがない場合はキャッシュを利用する（リスト以外の移動が該当する）
              console.log('+ use cache (note)')
              this.isCache = true
              this.addNoteViews(this.note.guid)
              // this.loadThumbnail()
              this.hideAd = false
              return
            }
          }
          console.log('- reload (note)')
          this.reload()
        })
        // } else {
        //   this.content = ''
      }
    },
    onFirstPart() {
      this.firstPartShow = !this.firstPartShow
    },
    onPrev() {
      if (this.isPrev) {
        this.doPostProcessing()
        const guid = this.noteGuids[this.indexOfNotes - 1]
        this.$router.replace({ path: `/note/${guid || adService.guid}` })
      }
    },
    onNext() {
      if (this.isNext) {
        this.doPostProcessing()
        const guid = this.noteGuids[this.indexOfNotes + 1]
        this.$router.replace({ path: `/note/${guid || adService.guid}` })
      }
    },
    async onReload() {
      this.doPostProcessing()
      this.$vuetify.goTo(0)
      // console.log('onReload', this.note.guid)
      noteMeta.removeNoteRepresentedResourceGuid(this.note.guid)
      this.evernote.removeRelatedNotesFromCache(this.note.guid)
      this.reload()
    },
    async onCacheInfo() {
      const result = await this.$refs.cacheInfoDialog.open(this.note)
      if (result) {
        this.doPostProcessing()
        this.onReload()
      }
    },
    onReloadTest() {
      this.reloadTestState = 0
      this.reloadTestDialog = true
    },
    // async onReloadTestChange(state) {
    //   this.reloadTestState = state
    //   switch (state) {
    //     case 1: {
    //       // reloading
    //       this.reloadTestMessage = '実行中'
    //       let err = false
    //       for (
    //         this.reloadTestCounter = 0;
    //         this.reloadTestCounter < 200;
    //         this.reloadTestCounter++
    //       ) {
    //         let result = await evernote.note(this.guid).catch(error => {
    //           console.log(error)
    //           this.reloadTestResult = error
    //           err = true
    //         })
    //         if (result.failed) {
    //           this.reloadTestResult = this.evernote.getErrorMessage(result)
    //           err = true
    //         }
    //         if (err) {
    //           break
    //         }
    //         this.reloadTestMessage += '.'
    //       }
    //       if (err) {
    //         this.reloadTestMessage = 'エラーが発生しました'
    //       } else {
    //         this.reloadTestMessage = '呼び出し完了です'
    //       }
    //       this.reloadTestState = 3
    //       break
    //     }
    //     case 2:
    //       // canceled
    //       this.reloadTestMessage = 'キャンセルされました'
    //       break
    //     default:
    //       this.reloadTestMessage = ''
    //   }
    // },
    onBack() {
      this.doPostProcessing()
      this.$router.go(-1)
    },
    // async onPreview(event) {
    //   // console.log(event)
    //   // hashIndex->NG（プロトコルは自動的に小文字に変換される
    //   if (event.srcElement.protocol === 'hashindex:') {
    //     const hashIndex = event.srcElement.pathname
    //     const hash = this.$store.state.resourceHashes[hashIndex]
    //     const resourceKeys = this.$store.state.resourceKeys
    //     // console.log(hashIndex)
    //     // console.log(hash)
    //     // console.log(resourceKeys)
    //     if (hash && resourceKeys) {
    //       const resourceKey = resourceKeys[hash]
    //       if (resourceKey) {
    //         this.$store.commit('setResourceHashIndex', hashIndex)
    //         // this.$router.push({
    //         //   name: 'resource',
    //         //   params: { key: resourceKey }
    //         // })
    //         // const url = evernote.getResourceURL(
    //         //   resourceKey.guid,
    //         //   resourceKey.prefix
    //         // )
    //         // window.open(url, resourceKey.guid)
    //         await this.$refs.downloadImagesDialog.open(
    //           resourceKey.guid,
    //           resourceKey.prefix
    //         )
    //       }
    //     }
    //     event.preventDefault()
    //   }
    // },
    async change(id) {
      this.$refs.changeDialog.open(this.note, id, true).then(result => {
        if (result) {
          indexedDB.notes.get(result.guid).then(note => {
            if (note) this.note = note
          })
        }
      })
    },
    onTitle() {
      this.change(0)
    },
    onNotebook() {
      this.change(2)
    },
    onTag() {
      this.change(3)
    },
    onReminder() {
      this.change(4)
    },
    onChange() {
      this.change(1)
    },
    async onFavorite(note, on) {
      this.$refs.favoriteUpdater.exec(note, on, true).then(result => {
        if (result) {
          indexedDB.notes.get(note.guid).then(note => {
            if (note) this.note = note
          })
        }
      })
    },
    onClose() {
      this.doPostProcessing()
      window.close()
    },
    onHome() {
      this.doPostProcessing()
      this.$router.push({ name: 'notes' })
    },
    setupFontSize() {
      this.contentStyle.fontSize = `${settings.fontSize}pt`
    },
    onChangeFontSize() {},
    onDelete() {
      this.$refs.deleteDialog.open(this.note).then(result => {
        if (result) {
          this.onBack()
        }
      })
    },
    // onDelete() {
    //   this.deleteDialog = false
    //   const guid = this.note.guid
    //   this.$refs.moveToTrashDialog.open('ゴミ箱へ移動', function() {
    //     return evernote.deleteNote(guid).then(results => {
    //       return {
    //         failed: results.failed,
    //         message: results.errorMessage,
    //         code: results.errorCode
    //       }
    //     })
    //   })
    // },
    // async onDeleted(deleted) {
    //   if (deleted) {
    //     await indexedDB.notes.delete(this.note.guid)
    //     // let storedNotes = this.$store.state.notes
    //     // if (storedNotes) {
    //     //   storedNotes = storedNotes.filter(n => n.guid !== this.note.guid)
    //     //   this.$store.commit('setNotes', storedNotes)
    //     //   this.onBack()
    //     // } else {
    //     //   this.onHome()
    //     // }
    //     notesCache.deleteNote(this.note.guid)
    //     this.onBack()
    //   }
    // },
    async loadResource(resourceDisplay, cacheOnly, loadNoLoad) {
      if (loadNoLoad || resourceDisplay.isLoadable) {
        resourceDisplay.setLoading()

        if (resourceDisplay.isThumbnailDisplayType) {
          const results = await evernote.loadResourceThumbnail(
            this.note.guid,
            resourceDisplay.resource.guid,
            cacheOnly
          )
          if (results) {
            resourceDisplay.thumbnailURL = results.url
            resourceDisplay.displayOnElement()
          } else {
            console.log('Failed to load thumbnail')
            const results = await evernote.loadResource(
              this.note.guid,
              resourceDisplay.resource.guid,
              resourceDisplay.resource.prefix,
              true
            )
            if (results) {
              resourceDisplay.setOpenInNew()
            } else {
              resourceDisplay.setLoadable()
            }
          }
        } else if (
          resourceDisplay.isInternalDisplayType &&
          resourceDisplay.resource
        ) {
          const results = await evernote.loadResource(
            this.note.guid,
            resourceDisplay.resource.guid,
            resourceDisplay.resource.prefix,
            cacheOnly
          )
          if (results) {
            resourceDisplay.url = results.url
            // resourceDisplay.setLoaded()
            resourceDisplay.displayOnElement()
            this.allImagesDisplayed = rdsService.allImagesDisplayed
          } else {
            resourceDisplay.setLoadable()
          }
          return results
        } else {
          resourceDisplay.setNoResource()
          console.log('Unknown display type')
        }
      }
    },
    async loadInitialReources() {
      rdsService.setupResourceDisplays(
        this.$refs['contentDiv'],
        this.$store.state.resources
      )
      this.hasImages = rdsService.hasImages
      let cacheOnly = settings.isImageDownloadManual
      let smallImage = false
      this.imageLoading = true
      this.numberOfDisplayedImage = 0
      this.numberOfImages = rdsService.numberOfImages
      for (const resourceDisplay of rdsService.resourceDisplays) {
        if (await this.loadResource(resourceDisplay, cacheOnly, smallImage)) {
          // cacheOnly = true
          // smallImage = true
          this.numberOfDisplayedImage = rdsService.numberOfDisplayedImage
        }
      }
      this.imageLoading = false
      this.allImagesDisplayed = rdsService.allImagesDisplayed
      this.loadThumbnail()
    },
    async loadAllImages() {
      this.allImagesDisplayed = true
      this.imageLoading = true
      this.numberOfDisplayedImage = 0
      this.numberOfImages = rdsService.numberOfImages
      for (const resourceDisplay of rdsService.imageResourceDisplays) {
        await this.loadResource(resourceDisplay, false)
        this.numberOfDisplayedImage = rdsService.numberOfDisplayedImage
      }
      this.imageLoading = false
    },
    async onDownloadImages() {
      this.$refs.downloadImagesDialog.open().then(result => {
        if (result) {
          this.loadAllImages()
        }
      })
    },
    async onContentObject(event) {
      const element = event.srcElement
      const noteGuid = this.note.guid

      if (element.tagName == 'IMG') {
        if (element.getAttribute('class') !== 'raw_img') {
          const resourceDisplay = rdsService.getResourceDisplay(element)
          if (resourceDisplay) {
            if (resourceDisplay.isInternalDisplayType) {
              if (resourceDisplay.isLoadable || resourceDisplay.noLoad) {
                if (this.loadResource(resourceDisplay, false, true)) {
                  event.preventDefault()
                }
              }
            } else if (resourceDisplay.isThumbnailDisplayType) {
              if (!resourceDisplay.url) {
                const results = await evernote.loadResource(
                  noteGuid,
                  resourceDisplay.resource.guid,
                  resourceDisplay.resource.prefix,
                  true
                )
                if (results && results.url) {
                  resourceDisplay.url = results.url
                } else {
                  this.$refs.loadResourceDialog.open(
                    'ダウンロード中',
                    function() {
                      return evernote
                        .loadResource(
                          noteGuid,
                          resourceDisplay.resource.guid,
                          resourceDisplay.resource.prefix,
                          false
                        )
                        .then(results => {
                          if (results.url) {
                            resourceDisplay.url = results.url
                            // resourceDisplay.setOpenInNew()
                            window.open(resourceDisplay.url)
                          }
                          return {
                            failed: results.failed,
                            message: results.errorMessage,
                            code: results.errorCode
                          }
                        })
                    }
                  )
                }
              }
            }
          } else {
            // 'noload' --> ここにはこない（はず？）
            console.log("noload (can't find)", element)
          }

          if (resourceDisplay && resourceDisplay.url) {
            window.open(resourceDisplay.url)
          }
        }
      } else {
        // console.log(element.tagName)
      }
    },
    onNoteNewTab(note) {
      let routeData = this.$router.resolve({
        name: 'note',
        params: { guid: note.guid },
        query: { single: 1 }
      })
      window.open(routeData.href, '_blank')
    },
    onNote(note) {
      this.$router.push({
        name: 'note',
        params: { guid: note.guid },
        query: { con: 1 }
      })
    },
    hideThubnail() {
      this.coverImageSrc = undefined
    },
    loadThumbnail() {
      if (this.coverImageSrc) {
        return
      }
      // noteMeta.setupRepresentedResource()  // ここで呼ぶと２回呼ばれる？
      noteMeta
        .getNoteRepresentedResourceGuid(this.note.guid)
        .then(resourceGuid => {
          if (resourceGuid) {
            this.evernote.loadResourceFromCache(resourceGuid).then(result => {
              // console.log('1:', resourceGuid, result)
              if (result) {
                this.coverImageSrc = result.url
                // element.style.display = 'block'
                // element.setAttribute('src', result.url)
              } else {
                this.evernote
                  .loadResourceThumbnailFromCache(resourceGuid)
                  .then(result => {
                    // console.log('2:', resourceGuid, result)
                    if (result) {
                      this.coverImageSrc = result.url
                      // element.style.display = 'block'
                      // element.setAttribute('src', result.url)
                    }
                  })
              }
            })
          }
        })
    },
    onHelp() {
      this.$refs.helpDialog.open()
    },
    onNoteSetting() {
      this.$refs.noteSettingDialog.open().then(result => {
        if (result) {
          this.setupFontSize()
        }
      })
    }
  }
}
</script>

<style>
/* https://stackoverflow.com/questions/50176824/card-with-scroll-in-vuetify */
.scroll {
  overflow-y: auto;
}
a {
  text-decoration: none;
}
a:link {
  color: #6699cc;
}
a:visited {
  color: #6699cc;
}
.icon {
  vertical-align: middle;
  width: 24px;
  margin-right: 2px;
}
.head {
  padding: 1.5em 0 0.5em 0;
  font-weight: bold;
  font-size: 110%;
}
.first_part {
  padding: 0.5em 1em 0 1em;
  margin-left: 12px;
  border-left: solid 5px rgba(200, 200, 200, 0.3);
}
pre {
  font-family: sans-serif, monospace;
  line-height: 100%;
  font-size: 70%;
}
img.displayed_flex {
  width: 100%;
  object-fit: scale-down;
  border-radius: 2.5px;
}
img.displayed_fix {
  padding: 2px 4px 4px 4px;
  border-radius: 7.5px;
  /* margin-left: auto;
  margin-right: auto;
  display: block; */
}
img.displayed_thumbnail {
  border-radius: 2.5px;
  border: 1px solid #c0c0c0;
  width: 175px;
  height: 175px;
}
img.loadable {
  width: 48px;
  height: 48px;
  vertical-align: middle;
  padding: 2px 2px 2px 0;
}
img.loading {
  width: 48px;
  height: 48px;
  vertical-align: middle;
  padding: 2px 2px 2px 0;
}
img.noload {
  width: 28px;
  height: 28px;
  vertical-align: middle;
  padding: 2px 2px 2px 0;
}
img.noresource {
  width: 28px;
  height: 28px;
  vertical-align: middle;
  padding: 2px 2px 2px 0;
}
img.open_in_new {
  width: 48px;
  height: 48px;
  vertical-align: middle;
  padding: 2px 2px 2px 0;
}

figure.hav {
  display: inline-block;
  margin: 0px 0px 5px 0px;
  padding-top: 5px;
  padding-bottom: 5px;
  vertical-align: top;
  width: 100%;
  /* background-color: #ccc; */
}
figure.hav img {
  max-width: 100%;
  height: auto;
  display: block;
}
figure.hav .caption {
  margin-top: 4px;
}
figure.hav .caption span {
  font-size: 9pt;
  vertical-align: middle;
  display: inline-block;
  /* color: red; */
  /* font-style: oblique; */
  /* text-align: left; */
}
figure.hav .caption img {
  vertical-align: middle;
  width: 24px;
  height: 24px;
  margin-right: 2px;
  display: inline;
  border: none;
}

h1 {
  font-size: 130%;
  padding: 0.5em 0 0.25em 0;
  /* color: red; */
}
h2 {
  font-size: 120%;
  padding: 0.5em 0 0.25em 0;
  /* color: blue; */
}
h3 {
  font-size: 110%;
  padding: 0.5em 0 0.25em 0;
  /* color: green; */
}
/* .file {
  font-size: 70%;
  margin: 0.5em;
  background-color: rgba(220, 220, 220, 0.3);
  border-radius: 14px;
  padding: 8px 10px 6px 5px;
} */
/* .file_image {
  background-color: rgba(247, 222, 6, 0.3);
}
.file_pdf {
  background-color: rgba(255, 120, 90, 0.3);
} */
img.coverimage_1 {
  width: 100px;
  height: 100px;
  /* object-fit: scale-down; */
  object-fit: cover;
  border-radius: 7.5px;
  margin-left: 4px;
  float: right;
}
img.raw_img {
  max-width: 100%;
  height: auto;
  vertical-align: bottom;
}
figure.raw_fig {
  display: inline-block;
  /* margin: 0px 0px 5px 0px; */
  vertical-align: top;
  /* background-color: #ccc; */
  /* background-color: red; */
}
figure.raw_fig figcaption {
  font-size: 9pt;
  /* font-style: oblique; */
  text-align: left;
}
figure.raw_fig figcaption img {
  vertical-align: middle;
  width: 20px;
  height: 20px;
  margin-right: 3px;
  display: inline;
  border: none;
}
div.noteBody table {
  /* border: solid 1px grey; */
  border-collapse: collapse;
  max-width: 100%;
  margin: 0.5em;
}
div.noteBody table th {
  border: solid 1px #707070;
  background-color: #808080;
  color: white;
  font-size: 75%;
  padding: 0 0.5em 0 0.5em;
}

div.noteBody table td {
  border: solid 1px grey;
  font-size: 75%;
  padding: 0 0.5em 0 0.5em;
}

pre {
  padding: 0.75em;
  margin: 0.25em;
  background-color: #606060;
  color: #ffffff;
  line-height: 1.75em;
  font-family: monospace;
  border-radius: 2px;
}
</style>
